import { combineReducers } from 'redux'

import { reducer as mfaReducer } from '../../../../../../Auth/Login/components/AppLoginMfaRegistration/DataAccess'

export default combineReducers({
  mfa: mfaReducer
})
